import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';
import { YoutubeShortsLogoComponent } from '../../../preview-common/youtube/youtube-shorts-logo/youtube-shorts-logo.component';
import { YoutubeMobileBottomNavComponent } from '../../../preview-common/youtube/youtube-mobile-bottom-nav/youtube-mobile-bottom-nav.component';

/**
 * Performance Max in YouTube Shorts (mobile): full-screen portrait image with
 * the action rail on the right and channel, Sponsored and description below.
 */
@Component({
    selector: 'app-pmax-youtube-mobile-05',
    imports: [
        CommonModule,
        MobileFrameComponent,
        YoutubeMobileBottomNavComponent,
        YoutubeShortsLogoComponent,
    ],
    templateUrl: './youtube-mobile-05.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-mobile-05.component.scss',
    ]
})
export class PmaxYoutubeMobile05PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the 4:5 portrait format. */
  readonly creativeFormat: CreativeFormat = 'portrait';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** Right-hand Shorts action rail. */
  readonly actions = [
    { icon: 'bi-heart', label: 'Like' },
    { icon: 'bi-chat-square-text', label: 'Comment' },
    { icon: 'bi-bookmark', label: 'Save' },
    { icon: 'bi-share', label: 'Share' },
  ];

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
